import styled from 'styled-components'

export const ButtonContainer = styled.div`
    position: fixed;
    bottom: 2em;
    right: 2em;
`
